import { render, staticRenderFns } from "./TitleName.vue?vue&type=template&id=660eb720&scoped=true&"
import script from "./TitleName.vue?vue&type=script&lang=js&"
export * from "./TitleName.vue?vue&type=script&lang=js&"
import style0 from "./TitleName.vue?vue&type=style&index=0&id=660eb720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660eb720",
  null
  
)

export default component.exports